.card {
  background: var(--color-primary-grey-000); /* PRIMARY_GREY_000 */
  border: var(--plume-border-card, 2px solid var(--color-primary-grey-900));
  border-radius: 18px;
  padding: 28px;
  display: flex;
  flex-direction: column;
  gap: 22px;
  box-shadow: var(--plume-shadow-card, 6px 6px 0 var(--color-primary-grey-900));
  transition:
    transform 0.22s ease,
    box-shadow 0.22s ease;
}

.card:hover {
  box-shadow: var(--plume-shadow-card-hover, 10px 10px 0 var(--color-complementary-yellow)); /* accent (yellow) sticker shadow */
  transform: var(--plume-hover-shift, translate(-2px, -2px));
}

.card__head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
}

.card__name {
  font-size: 18px; /* HEADING_XXS */
  font-weight: 700;
  color: var(--color-primary-grey-900); /* PRIMARY_GREY_900 */
  margin: 0;
}

/* segmented light/dark background toggle */
.seg {
  display: inline-flex;
  border-radius: 9999px;
  border: 2px solid var(--color-primary-grey-900); /* PRIMARY_GREY_900 */
  overflow: hidden;
  flex-shrink: 0;
}

.seg__btn {
  padding: 6px 15px;
  border: none;
  background: var(--color-primary-grey-000); /* PRIMARY_GREY_000 */
  color: var(--color-primary-sand-900); /* text-2 */
  font-family: inherit;
  font-size: 13px;
  font-weight: 700;
  cursor: pointer;
  transition:
    background 0.18s ease,
    color 0.18s ease;
}

.segActive {
  background: var(--color-primary-grey-900); /* PRIMARY_GREY_900 */
  color: var(--color-primary-grey-000);
}

.card__stage {
  border-radius: 12px;
  /* White (not sand) so nobody mistakes the preview background for part of the logo. A thin neutral
     frame keeps the white stage a defined panel on the white card. */
  background: var(--color-primary-grey-000); /* PRIMARY_GREY_000 */
  border: 1px solid var(--color-primary-sand-200); /* PRIMARY_SAND_200 */
  /* Fixed (not min-) height so all three stages match regardless of each logo's aspect ratio — keeps
     the download rows aligned across cards and the cards compact. */
  height: 200px;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 20px;
  transition: background 0.25s ease;
}

.card[data-mode='dark'] .card__stage {
  background: var(--color-primary-grey-900); /* PRIMARY_GREY_900 (dark background preview) */
}

.card__stage img {
  /* Fit within the fixed-height stage, preserving aspect ratio. The per-logo max-width (inline) caps
     width for optical balance; max-height keeps a tall (square-viewBox) logo from overflowing. */
  max-width: 100%;
  max-height: 100%;
  width: auto;
  height: auto;
}

.dlRow {
  display: flex;
  gap: 10px;
}

.dl {
  flex: 1;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 7px;
  padding: 11px 12px;
  font-size: 13px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.06em;
  border-radius: 9999px;
  border: 2px solid var(--color-primary-grey-900); /* PRIMARY_GREY_900 */
  background: var(--color-primary-grey-000); /* PRIMARY_GREY_000 */
  color: var(--color-primary-grey-900); /* PRIMARY_GREY_900 */
  cursor: pointer;
  transition: all 0.18s ease;
}

.dl:hover {
  background: var(--color-complementary-yellow); /* COMPLEMENTARY_YELLOW (accent) */
  border-color: var(--color-primary-grey-900);
  color: var(--color-primary-grey-900); /* accent-on */
}

.dlPrimary {
  background: var(--color-primary-grey-900); /* PRIMARY_GREY_900 */
  color: var(--color-primary-grey-000);
}

.dlPrimary:hover {
  background: var(--color-primary-grey-700); /* PRIMARY_GREY_700 (ink-soft) */
  border-color: var(--color-primary-grey-900);
  color: var(--color-primary-grey-000);
}
